import { Controller } from "@hotwired/stimulus"

// Přepíná mezi solo (jedna fotka) a pár (před/po) sekcí formuláře galerie
// a ukazuje živý náhled zvolené fotky.
export default class extends Controller {
  static targets = ["solo", "pair"]

  connect() {
    this.toggle()
  }

  toggle() {
    const checked = this.element.querySelector('input[name="gallery_item[kind]"]:checked')
    const isPair = checked?.value === "pair"
    this.pairTarget.hidden = !isPair
    this.soloTarget.hidden = isPair
  }

  preview(event) {
    const input = event.target
    const img = input.closest("[data-upload]")?.querySelector("[data-preview]")
    const file = input.files?.[0]
    if (!img || !file) return
    img.src = URL.createObjectURL(file)
    img.classList.remove("hidden")
  }
}
